import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

const BlackButton = styled(Button)(({ endIcon }) => ({
  color: '#ffffff',
  textAlign: endIcon ? 'left' : 'center',
  borderRadius: 48,
  minWidth: 210,
  fullWidth: true,
  justifyContent: endIcon ? 'flex-start' : 'flex-center',
  borderColor: '#000000',
  backgroundColor: '#000000 !important',
  '&:hover': {
    borderColor: '#395B64',
    color: '#000000',
    backgroundColor: '#ffffff !important',
  },
  '&:disabled': {
    opacity: 0.3,
    color: '#ffffff',
  },
}));

const BlackButtonLabel = styled(Box)(() => ({
  flexGrow: 1,
  fontFamily: 'Haffer',
  fontWeight: 500,
  fontSize: '18px',
  fontStyle: 'normal',
  textTransform: 'none',
  '&:hover': {
    borderColor: '#395B64',
  },
}));

const SelectBlackButton = (props) => {
  const theme = useTheme();
  const { label, ...other } = props;
  return (
    <BlackButton fullWidth {...other} theme={theme} variant="outlined" size="large">
      <BlackButtonLabel>{label}</BlackButtonLabel>
    </BlackButton>
  );
};

export default SelectBlackButton;
